import './style.css';
import BudgetForm from '../../components/BudgetForm';

function BudgetContainer(){
    return <main className="home-container">
        <div className="layout-wrapper">
            <h1>Solicitá tu presupuesto</h1>
            <div className="info-card">
                <p>Completá el formulario con todos tus datos. Te responderemos a la brevedad.</p>
            </div>
            <BudgetForm />
        </div>
    </main>
}

export default BudgetContainer;